import { observer } from 'mobx-react-lite';

import { TabBar } from '@/features/tabs';
import { tabStore } from '@/features/tabs/tabs.store';
import { cn } from '@/lib/utils';
import {
  WINDOW_BUTTON_POSITION_X,
  settingsStore,
} from '@/stores/settings.store';
import { inElectron, isMac } from '@/utils';

import { XStack } from '../../ui/layout/layout';

import { chromelessWindow } from './content-corner';
import { WindowControls } from './WindowControls';
import { WindowNavigationControl } from './WindowNavigationControl';

/** Width of the native macOS traffic-light row (3 circles, ~14px wide and gaps). */
const TRAFFIC_LIGHT_WIDTH = 70;

export const Navbar = observer(() => {
  if (!inElectron()) return null;

  if (chromelessWindow()) {
    if (isMac()) {
      if (settingsStore.isMainWindowFullScreen) return null;
      return (
        <div className="absolute inset-x-0 top-0 z-30 h-12 drag-region pointer-events-none" />
      );
    }
    return (
      <XStack className="relative h-12 shrink-0 items-center justify-end border-b border-border-subtle">
        <div className="flex-1 h-full drag-region" />
        <WindowControls />
      </XStack>
    );
  }

  const leftClearance =
    isMac() && !settingsStore.isMainWindowFullScreen
      ? WINDOW_BUTTON_POSITION_X + TRAFFIC_LIGHT_WIDTH
      : 0;
  const leftStyle: React.CSSProperties = { paddingLeft: leftClearance };

  return (
    // no z-index on purpose: the controls below carry their own z-50
    <XStack className="shell relative h-12 shrink-0 titlebar-drag-region">
      {/* pointer-events-none lets the sidebar resize handle receive hover and
          drag along this section's right edge; the controls re-enable it */}
      <XStack
        className="relative z-50 pointer-events-none items-start shrink-0"
        style={leftStyle}
      >
        <WindowNavigationControl />
      </XStack>
      <div
        className={cn(
          'flex-1 min-w-0',
          !tabStore.showTabBar && 'h-full drag-region'
        )}
      >
        {tabStore.showTabBar && <TabBar />}
      </div>
    </XStack>
  );
});
